var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 31,
    viewBox: "0 0 15 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "be5r3gwska",
    d: "M0.957 0.877L3.861 0.877 3.861 8.099 0.957 8.099z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t8aur5leic",
    d: "M0.913 0.877L3.818 0.877 3.818 8.099 0.913 8.099z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wcoihz6nbe",
    d: "M0 0.877L2.905 0.877 2.905 8.099 0 8.099z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(5 .123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hte74qkt8b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#be5r3gwska"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M1.84 8.099s-1.69-2.67-.396-4.516C2.74 1.737 2.523.877 2.523.877s2.714 2.688.413 7.204c-.018-2.598-.647-2.473-.647-2.473s-.63-.233-.45 2.49",
    mask: "url(#hte74qkt8b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M7.414 9V6.85H7.25v2.146c-.477-.004-.657-.045-1.221-.172-.01-.212 0 19.298 0 19.298H8.63V8.825s-.288.163-1.217.174m-.47 1.667c.257 0 .465.207.465.464 0 .256-.208.464-.465.464s-.466-.208-.466-.464c0-.257.209-.464.466-.464m0 4.972c.257 0 .465.207.465.464 0 .256-.208.464-.465.464s-.466-.208-.466-.464c0-.257.209-.464.466-.464m.698 3.328c0 .128-.104.232-.233.232-.128 0-.232-.104-.232-.232s.104-.232.232-.232c.129 0 .233.104.233.232m-1.164 2.358c0-.256.209-.464.466-.464s.465.208.465.464c0 .257-.208.465-.465.465s-.466-.208-.466-.465m.93 5.202c-.192 0-.348-.155-.348-.348 0-.192.156-.348.349-.348.193 0 .349.156.349.348 0 .193-.156.348-.35.348m.467-3.817c-.086 0-.156-.07-.156-.156 0-.085.07-.155.156-.155s.155.07.155.155c0 .086-.07.156-.155.156m-.233-8.19c-.386 0-.698-.312-.698-.697 0-.384.312-.696.698-.696.386 0 .698.312.698.696 0 .385-.312.697-.698.697",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(11 .123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f23qdn844d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t8aur5leic"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M1.796 8.099s-1.689-2.67-.395-4.516S2.48.877 2.48.877s2.714 2.688.413 7.204c-.018-2.598-.647-2.473-.647-2.473s-.629-.233-.449 2.49",
    mask: "url(#f23qdn844d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M14.065 18.279c-.03 0-.06-.012-.081-.033l-.614-.613-.621.62c-.023.022-.052.034-.081.034-.03 0-.058-.012-.081-.034l-.526-.524v1.926l.607.604.62-.62c.023-.021.052-.033.082-.033.03 0 .06.012.08.034l.615.612.602-.601v-1.925l-.521.52c-.022.02-.051.033-.081.033",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M14.065 20.527c-.03 0-.06-.012-.081-.033l-.614-.613-.621.62c-.023.022-.052.034-.081.034-.03 0-.058-.012-.081-.034l-.525-.524v1.927l.606.603.62-.62c.023-.021.052-.033.082-.033.03 0 .06.012.08.034l.615.612.602-.601v-1.925l-.521.52c-.022.02-.051.033-.081.033M14.065 16.03c-.03 0-.06-.011-.081-.032l-.614-.613-.621.62c-.023.022-.052.034-.081.034-.03 0-.058-.012-.081-.034l-.526-.525v1.926l.607.605.62-.62c.023-.021.052-.033.082-.033.03 0 .06.012.08.034l.615.612.602-.601v-1.925l-.521.52c-.022.02-.051.033-.081.033",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M14.065 22.775c-.03 0-.06-.012-.081-.033l-.614-.613-.621.62c-.023.022-.052.034-.081.034-.03 0-.058-.012-.081-.034l-.524-.523v1.927l.605.603.62-.62c.023-.022.052-.034.082-.034.03 0 .06.012.08.034l.615.612.602-.601v-1.925l-.521.52c-.022.02-.051.033-.081.033M14.145 27.238c-.02.02-.05.033-.08.033s-.06-.012-.082-.033l-.613-.612-.622.62c-.022.022-.05.033-.08.033s-.059-.011-.08-.033l-.524-.522v1.399h2.602v-1.405l-.52.52zM12.668 11.267l.62-.62c.023-.021.052-.033.082-.033.03 0 .06.012.08.033l.615.612.602-.6V8.825s-.287.163-1.217.174V6.85h-.164v2.146c-.477-.004-.657-.045-1.221-.172-.002-.041-.003.672-.004 1.837l.607.605zM14.065 13.782c-.03 0-.06-.012-.081-.033l-.614-.613-.621.62c-.023.023-.052.034-.081.034-.03 0-.058-.01-.081-.034l-.526-.525v1.926l.607.606.62-.62c.023-.022.052-.034.082-.034.03 0 .06.012.08.034l.615.612.602-.6v-1.926l-.521.52c-.022.021-.051.033-.081.033",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M13.29 26.384c.02-.021.05-.033.08-.033s.06.012.081.033l.614.612.602-.6V24.47l-.522.52c-.02.02-.05.033-.08.033s-.06-.012-.08-.033l-.615-.612-.622.62c-.022.022-.05.033-.08.033s-.059-.011-.08-.033l-.525-.523.001 1.927.604.602.621-.62zM14.065 11.534c-.03 0-.06-.012-.081-.033l-.614-.613-.621.62c-.023.023-.052.034-.081.034-.03 0-.058-.01-.081-.034l-.526-.524v1.925l.607.606.62-.62c.023-.022.052-.034.082-.034.03 0 .06.012.08.034l.615.612.602-.6V10.98l-.521.52c-.022.021-.051.033-.081.033",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(0 .123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o6jp4tl0ef",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wcoihz6nbe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M.883 8.099S-.806 5.429.488 3.583 1.566.877 1.566.877 4.28 3.565 1.98 8.08c-.018-2.598-.647-2.473-.647-2.473s-.629-.233-.449 2.49",
    mask: "url(#o6jp4tl0ef)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M1.538 9V6.85h-.164v2.146c-.477-.004-.657-.045-1.22-.172-.01-.212 0 19.298 0 19.298h2.601V8.825s-.287.163-1.217.174",
    transform: "translate(0 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirty);
export default __webpack_public_path__ + "static/media/thirty.cbc7f1326a9ca335852130d16c4622c9.svg";
export { ForwardRef as ReactComponent };